import React from 'react';

const DaysOfWeekSelector = ({ days, selectedDays, onChange, error, touched }) => {
  return (
    <fieldset className="sm:col-span-6">
      <legend className="block text-sm font-medium leading-6 text-gray-900">
        Days <span className="text-red">*</span>
      </legend>

      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-6 md:col-span-2">
        {days.map((day) => (
          <div key={day.code} className="sm:col-span-2">
            <div className="mt-2 space-y-6 block w-full rounded-md border border-gray-300 py-1.5 px-2 text-gray-900 shadow-sm sm:max-w-xs sm:text-sm sm:leading-6">
              <div className="relative flex gap-x-3">
                <div className="flex h-6 items-center">
                  <input
                    id={day.code}
                    name="daysOfWeek"
                    type="checkbox"
                    value={day.code}
                    checked={selectedDays?.includes(day.code)}
                    onChange={onChange}
                    className="rounded border-gray-300 text-primary focus:ring-primary"
                  />
                </div>
                <label htmlFor={day.code} className="text-gray-900 w-full">
                  {day.label}
                </label>
              </div>
            </div>
          </div>
        ))}
      </div>

      {touched && error && <p className="text-error text-xs mt-1">{error}</p>}
    </fieldset>
  );
};

export default DaysOfWeekSelector;
